import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import type { ShipperPortalConfig } from '@/api/types';
import { REDACTION_SENTINEL } from '@/api/types';
import { Field, FormShell, SecretInput } from './shared';

interface Props {
  initial: ShipperPortalConfig | null;
  onSubmit: (config: Partial<ShipperPortalConfig>) => void;
  submitting: boolean;
  onCancel: () => void;
  onReset?: () => void;
}

export function ShipperPortalForm({ initial, onSubmit, submitting, onCancel, onReset }: Props): JSX.Element {
  const { t } = useTranslation();
  const [baseUrl, setBaseUrl] = React.useState(initial?.baseUrl ?? '');
  const [username, setUsername] = React.useState(initial?.username ?? '');
  const [password, setPassword] = React.useState(initial?.password ?? '');
  const [userEmail, setUserEmail] = React.useState(initial?.userEmail ?? '');

  return (
    <form
      id="integration-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          baseUrl: baseUrl.trim(),
          username: username.trim(),
          password: password === REDACTION_SENTINEL || !password ? REDACTION_SENTINEL : password,
          userEmail: userEmail.trim(),
        });
      }}
    >
      <FormShell submitting={submitting} onCancel={onCancel} onReset={onReset}>
        <Field label={t('integrations.form.shipper-portal.baseUrl')} htmlFor="sp-url" required>
          <Input
            id="sp-url"
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            placeholder="https://shipperportal-v2.test.flash.global"
            required
          />
        </Field>
        <Field label={t('integrations.form.shipper-portal.username')} htmlFor="sp-user" required>
          <Input id="sp-user" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </Field>
        <Field label={t('integrations.form.shipper-portal.password')} htmlFor="sp-pwd" required hint={t('integrations.form.shipper-portal.passwordHint')}>
          <SecretInput id="sp-pwd" value={password} onChange={setPassword} />
        </Field>
        <Field label={t('integrations.form.shipper-portal.userEmail')} htmlFor="sp-email" required hint={t('integrations.form.shipper-portal.userEmailHint')}>
          <Input
            id="sp-email"
            type="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            placeholder="shipperedi@redspher.com"
            required
          />
        </Field>
      </FormShell>
    </form>
  );
}
